import { useState, useEffect } from 'react';

import { Box, styled } from '@mui/material';

import { useNavigate } from 'react-router';

import { AppContextProvider } from '../../context/AppContext';
import { useAuthAccess, authTargetTypes } from '../../hooks/useAuthAccess';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';

import { getLayoutFrame } from "../../configs/layoutFrameConfigs"

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

export default function Layout() {

  const navigate = useNavigate();

  const { checkIsLogin } = useAuthAccess(authTargetTypes.customer);
  const { promptMessage } = useSystemPrompt();
  const { getRoute } = useSystemRoutes(routeTypes.customer);

  useEffect(() => {

    const checkNotAllowed = () => {
      if (!checkIsLogin()) {
        // navigate("/", {
        //   state: {
        //     promptMessageAction: getPromptMessageAction()
        //   }
        // });

        navigate(getRoute(`login`));
        promptMessage(false, `Please login again`)

      }
    }

    checkNotAllowed();

  }, [checkIsLogin, navigate, promptMessage])

  const RenderFrameComponent = () => {
    return getLayoutFrame({ routeType: routeTypes.customer })
  }

  return (
    <AppContextProvider>
      <StyledRoot>

        <RenderFrameComponent />

      </StyledRoot>
    </AppContextProvider>
  );
}
